module.exports = __webpack_public_path__ + "static/media/sf_800.672970790d871da8b4e0fa4d615af3fb.png";